import { inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment as env } from 'src/environments/environment';
import { TenantLocalService } from 'src/app/core/services/api/tenantlocal.service';

export class Api {

    private tenantlocalService = inject(TenantLocalService);

    /** @description Servicio para las peticiones HTTP */
    protected http: HttpClient = inject(HttpClient);

    /** @description URI de la API Backend */
    protected source = env.app_urls.source;

    protected url = `${this.source}/api`

    protected urlv2 = `${this.source}/api/v2`

    protected prefix = () => '';

    protected link(path: string): string {
        return `${this.urlv2}/${this.prefix()}/${path}`
    }

   protected getTenantHeaders(): { [header: string]: string } {
  const token = localStorage.getItem('access_token');
  const tenant = this.tenantlocalService.tenantSlug;
  const tenantId = tenant !== null ? tenant.toString() : '';
  return {
    Authorization: `Bearer ${token}`,
    'tenant-id': tenantId
  };
}

}